import axios from 'axios';
import { IParamsRequest } from 'redhotpie-shared-lib/interfaces/IAction';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import { MEMBER_SEARCH_SCREEN } from '../constants/category';
import urls from './urls';

class memberSearchApi {
  static getUserSearchSettings(): Promise<IApiResponse<any>> {
    return axios.get(urls.GET_USER_SEARCH_SETTINGS, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getNicheSearch(): Promise<IApiResponse<any>> {
    return axios.get(urls.GET_NICHE_SEARCH, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getListEntitiesSearch(categoryId: string, params: IParamsRequest): Promise<IApiResponse<any>> {
    const url = urls.GET_LIST_ENTITIES.replace(
      '{EntitySearch}',
      params && params.url ? params.url : MEMBER_SEARCH_SCREEN.FILTERS_ENTITIES[categoryId].url
    );
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postUsersMemberSearchProfile(params: IParamsRequest, isSpotlight: boolean): Promise<IApiResponse<any>> {
    let url = urls.GET_PROFILE_SEARCH;
    if (isSpotlight) {
      url = `${urls.POST_SPOTLIGHT_USER}`;
    }
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postUserMemberSearchAction(id: string, index: number, actionType: string, params: IParamsRequest): Promise<IApiResponse<any>> {
    const url = urls.UPDATE_ACTION_USER_SEARCH.replace('{id}/{Action}', `${id}/${actionType}`);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postGetUserSavedSearches(params?: IParamsRequest): Promise<IApiResponse<any>> {
    if (params) {
      const url = urls.GET_USER_SAVED_SEARCHES;
      return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
    }
    return axios.get(urls.GET_USER_SAVED_SEARCHES, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteUserSavedSearches(id: number): Promise<IApiResponse<any>> {
    const url = urls.DELETE_USER_SAVED_SEARCHES.replace('{id}', id.toString());
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getSpotlightMember(params: IParamsRequest = {}): Promise<IApiResponse<any>> {
    const url = `${urls.GET_SPOTLIGHT_USER}?page=${params.pageNumber}&size=${params.pageSize}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getSpotLightFeatured(): Promise<IApiResponse<any>> {
    const url = `${urls.GET_SPOTLIGHT_FEATURED}?page=1&size=10`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default memberSearchApi;
